module.exports = __webpack_public_path__ + "img/down2-en.b095bed9.png";